import _toConsumableArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// TODO: change signature of components
// - if replicants then each replicant should get data-ct-component
//   instead of around the whole thing ?
// - a way to specify the number of headings to return or which headings to return
//   ie. 1st and last for an accordion panel?
// - Navigation
import $ from 'jquery';
import { trim } from './util/text';
import { getMetaContent } from './util/selector';
/**
 * Promise to wait for pageBottom() call in DTM, resolves some timing issues for SPA's
 * TODO: add a larger timeout here or change to while based, what if AdobeLoaded is never true
 * @param {Object} satellite the window._satellite object
 */

export var waitForAdobe = function waitForAdobe(satellite) {
  return new Promise(function (resolve, reject) {
    if (!satellite) {
      return reject(new Error('_satellite not defined'));
    }

    var wait = function wait() {
      if (satellite.getVar('AdobeLoaded')) {
        return resolve();
      }

      setTimeout(wait, 30);
    };

    wait();
  });
};
/**
 * Simple way to add an item to a Set if truthy, adding to Set.prototype
 * not working in IE 11.
 * @param {*Set} setObj the Set object to update
 * @param {*} value the value to add to the set if truthy
 */

export var addToSetIfTruthy = function addToSetIfTruthy(setObj, value) {
  if (value) {
    setObj.add(value);
  }
};
/**
 * Get trimmed text from an element, looks at text() and falls back to
 * different attributes if missing
 * @param {jQuery} element element to get text for
 */

export var getElementText = function getElementText(element) {
  if (!element) return ''; // edge case

  var text = trim(element.attr('data-ct-header'));

  if (text && !['true', '1'].includes(text)) {
    return text;
  }

  text = trim(element.text());

  if (!text) {
    // special case for images/logos
    var img = element.children('img').first();
    text = trim(img.attr('alt')) || trim(img.attr('title')) || trim(img.attr('aria-label'));
  }

  return text || trim(element.attr('value')) || trim(element.attr('title')) || trim(element.attr('aria-label')) || '';
};
/**
 * Find all headers between 2 elements
 * @param {jQuery} fromElement the element to start searching from
 * @param {jQuery} toElement the element to stop searching at
 */

export var getHeadersBetween = function getHeadersBetween(fromElement, toElement) {
  var headers = [];
  var headerSelector = 'h1, h2, h3, h4, h5, h6, header, [data-ct-header]';
  fromElement.find('*').each(function (index, element) {
    element = $(element);

    if (element.is(headerSelector)) {
      headers.push(getElementText(element));
    }

    if (element.is(toElement)) {
      return false;
    }
  });
  return headers;
};
/**
 * Gets specific headers from a list
 * data-ct-headers is optional and tells us which headers to extract
 * from the result of getHeadersBetween(), options are split on '|' and
 * passed to separate slice calls
 *  which === -1 = headers.slice(-1), default
 *  which === 0,1|-1 = headers.slice(0,1), headers.slice(-1)
 *  which === 3,-1 = headers.slice(3,-1)
 *  which == 0, headers.slice(0)
 * @param {*String} which value from data-ct-headers
 * @param {*Array} headers headers obtained from getHeadersBetween()
 */

export var getWantedHeaders = function getWantedHeaders(which, headers) {
  var wanted = which.split('|').reduce(function (acc, slice) {
    var _slice$split$map = slice.split(',').map(function (num) {
      return parseInt(num, 10);
    }),
        _slice$split$map2 = _slicedToArray(_slice$split$map, 2),
        start = _slice$split$map2[0],
        end = _slice$split$map2[1];

    return [].concat(_toConsumableArray(acc), _toConsumableArray(headers.slice(start, end)));
  }, []);
  return wanted;
};
/**
 * returns a clean pathname appropriate for clicktracking
 * @param {String} pathname current location.pathname
 */

export var getCleanPathname = function getCleanPathname(pathname) {
  return pathname.replace(/^\/|\/$/g, '') || 'index';
};
/**
 * returns a Set with the following items (if truthy)
 * 1. URL with leading + trailing slash stripped
 * 2. component name (value of data-ct-component)
 * 3. last header between data-ct-component and clicked link
 * 4. link text
 * @param {jQuery} link the link to track click for
 */

export var getComponentInfo = function getComponentInfo(link) {
  var headers = [];
  var componentName; // <meta name="click-tracking" content="off"> turns click-tracking off

  if (getMetaContent('click-tracking') === 'off') return; // ignore if link or any ancestors have data-ct-ignore attribute

  if (link.closest('[data-ct-ignore]').length) return;
  var component = link.closest('[data-ct-component]');

  if (component.length) {
    componentName = trim(component.attr('data-ct-component'));
    headers = getHeadersBetween(component, link);
  } else {
    componentName = 'body';
    headers = getHeadersBetween($('body'), link);
  }

  var wantedHeaders = getWantedHeaders(trim(component.attr('data-ct-headers')) || '-1', headers);
  var info = new Set([getCleanPathname(location.pathname)]);
  addToSetIfTruthy(info, componentName);
  wantedHeaders.map(function (header) {
    return addToSetIfTruthy(info, header);
  });
  addToSetIfTruthy(info, getElementText(link));
  return info;
};
export var trackClick = function trackClick(evt) {
  var link = $(evt.currentTarget);
  var info = getComponentInfo(link);
  if (!info) return;

  if (info.size < 3) {
    // throw instead?
    console.warn("Click-tracking expects at least 3 levels of properties to be set, ".concat(info.size, " found (").concat(_toConsumableArray(info).join(', '), ")."));
  } // data should now look like:
  // [current URL, Component Name, Component Heading, Link text]


  var _window = window,
      digitalData = _window.digitalData,
      _satellite = _window._satellite;

  if (digitalData && typeof digitalData.actions.item !== 'undefined' && _satellite) {
    digitalData.actions = {
      item: 'clicktracking',
      value: _toConsumableArray(info).join('|')
    }; // eslint-disable-next-line no-underscore-dangle

    _satellite.track('actiontracking');

    console.debug(digitalData.actions);
  }
};
export var initClickTracking = function initClickTracking() {
  var trackFunc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : trackClick;
  var selectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'a, button, input[type="submit"]';
  var KEY_SPACE = 32;
  var KEY_ENTER = 13;
  $(document.body).on('mousedown', selectors, trackFunc) // mousedown gets middle clicks too
  .on('keydown', selectors, function (evt) {
    if (evt.keyCode === KEY_SPACE || evt.keyCode === KEY_ENTER) {
      trackFunc(evt);
    }
  });
};
export default initClickTracking;